import { type KeyResultAttributes } from './generated/KeyResultAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface KeyResult extends KeyResultAttributes {}

@model
class KeyResult extends ApplicationModel {
  // Start auto-generated
  static typename: 'KeyResult' = 'KeyResult';
  get typename(): 'KeyResult' {
    return 'KeyResult';
  }

  static internalTypename: 'KeyResult' = 'KeyResult';
  get internalTypename(): 'KeyResult' {
    return 'KeyResult';
  }

  static terminologyName = 'Key result';

  static filterType = 'KeyResultFilters!';
  static filters = { id: '[ID!]', goalId: 'ID' };

  static fields = {
    commentsCount: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    goalId: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    path: attr({ readable: true }),
    position: attr({ readable: true }),
    projectId: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    workflowStatusId: attr({ readable: true }),
    assignedToUser: attr.belongsTo({ readable: true, typename: 'User' }),
    createdByUser: attr.belongsTo({ readable: true, typename: 'User' }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    goal: attr.belongsTo({ readable: true, typename: 'Goal' }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    terminology: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    workflowStatus: attr.belongsTo({
      readable: true,
      typename: 'WorkflowStatus',
    }),
    childRecordLinks: attr.hasMany({
      args: { filters: 'RecordLinkFilters' },
      readable: true,
    }),
    comments: attr.hasMany({ readable: true }),
    parentRecordLinks: attr.hasMany({
      args: { filters: 'RecordLinkFilters' },
      readable: true,
    }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default KeyResult;
